import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import {Accordion, AccordionDetails, AccordionSummary} from "../../../../shared/ui/CustomAccordion";
import TestItemCard from "../../../../shared/ui/TestItemCard";

export interface QuestionResponse {
    letter: string;
    response: string;
}

export interface LiteracyQuestion {
    id?: string | number;
    q_obs: any;
    user_answer: string;
    is_right_answer: boolean;
    q_responses: QuestionResponse[];
    [key: string]: any;
}

export interface LiteracyStudentAnswerItem {
    id: string | number;
    q_data: string;
    q_obs: string;
    difficulty?: string | number;
    questions: LiteracyQuestion[];
}

export interface LiteracyTestItemsProps {
    locationUrl: string;
    studentAnswers: LiteracyStudentAnswerItem[];
    testId: string;
    isPrinting: boolean;
}

const LiteracyTestItems = ({
                               locationUrl,
                               studentAnswers,
                               testId,
                               isPrinting
                            } : LiteracyTestItemsProps) => {
    const isAnswerReport = locationUrl === "raspunsuri";

    return (
        <>
            {studentAnswers.map((item, itemIndex) => (
                <Box
                    key={item.id ?? itemIndex}
                    sx={{
                        border: '1px solid #eee',
                        borderRadius: 0.5,
                        padding: 2,
                        marginBottom: 2,
                        marginTop: 2
                    }}
                >
                    <Box sx={{my: {xs: 1, md: 2}}} width="100%">
                        <Typography variant="body2" color="text.disabled" my={1}>
                            {testId}_{item.id}
                        </Typography>

                        {item.q_data && (
                            <Typography
                                component="div"
                                width="100%"
                                variant="body1"
                                mb={2}
                                dangerouslySetInnerHTML={{ __html: item.q_data }}
                            />
                        )}

                        {item.q_obs && (
                            <>
                                <Typography variant="body2" color="text.disabled" mb={2}>
                                    TEXT
                                </Typography>
                                <Accordion defaultExpanded={isPrinting}>
                                    <AccordionSummary
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Typography variant="body2" color="text.disabled">Text {itemIndex + 1}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography
                                            component="div"
                                            width="100%"
                                            variant="body2"
                                            mb={2}
                                            dangerouslySetInnerHTML={{ __html: item.q_obs }}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </>
                        )}

                        <Typography variant="body2" color="text.disabled" mb={2}>
                            INTREBARI
                        </Typography>

                        {item.questions.map((question, qIndex) => (
                            <TestItemCard
                                key={question.id ?? qIndex}
                                question={question}
                                isCustomItemPreview={false}
                                testId={testId}
                                difficulty={item.difficulty}
                                isAnswerReport={isAnswerReport}
                                isPrinting={isPrinting}
                            />
                        ))}
                    </Box>
                </Box>
            ))}
        </>
    )
}

export default LiteracyTestItems;